import { render, staticRenderFns } from "./gspcAddEdit.vue?vue&type=template&id=589a0c41"
import script from "./gspcAddEdit.vue?vue&type=script&lang=js"
export * from "./gspcAddEdit.vue?vue&type=script&lang=js"
import style0 from "./gspcAddEdit.vue?vue&type=style&index=0&id=589a0c41&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports